import { actionTypes } from '../actions/types';

const initState = {
  isLoading: false,
  user: null,
  error: null,
  authLoading: true,
};

// Contains the player's User info after authentciation
export default (state = initState, action = {}) => {
  switch (action.type) {
    case actionTypes.FETCH_USER:
      return {
        ...state,
        isLoading: true,
        user: null,
        error: null,
      };
    case actionTypes.FETCHED_USER:
      return {
        ...state,
        isLoading: false,
        user: action.data,
        error: null,
      };
    case actionTypes.USER_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        user: null,
        error: true,
      };
    case actionTypes.UPDATE_USER:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actionTypes.UPDATED_USER:
      return {
        ...state,
        isLoading: false,
        user: {
          ...state.user,
          ...action.data,
        },
      };
    case actionTypes.UPDATE_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    case actionTypes.SIGN_OFF:
      return {
        ...state,
        isLoading: false,
        user: null,
      };
    case actionTypes.SET_AUTH_LOADING:
      return {
        ...state,
        authLoading: action.data,
      };
    default:
      return state;
  }
};
